import type { Node2d } from "../mesh"

export const sortNodesXY = <T extends Node2d>(nodes: T[]): T[] =>
  nodes.sort((a, b) => a.x - b.x || a.y - b.y)
